import 'slick-carousel'
const MONUT_POINT = 'js-indexSlider'
const BREAKPOINT_WIDTH = 600

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById(MONUT_POINT)
  if (!element) return
  const isDesktop = window.innerWidth > BREAKPOINT_WIDTH

  $(`#${MONUT_POINT}`).slick({
    autoplay: true,
    autoplaySpeed: 5000,
    centerMode: true,
    slidesToShow: 1,
    centerPadding: 0,
    prevArrow: $(`.${MONUT_POINT}-prev`),
    nextArrow: $(`.${MONUT_POINT}-next`),
    dots: true,
  })

  // 画像をセット
  const itemElements = element.getElementsByClassName('js-indexSlider-item')
  Array.from(itemElements).forEach((el) => {
    el.style.backgroundImage = `url(${
      isDesktop ? el.dataset.imageDesktop : el.dataset.imageMobile
    })`
  })
})
